export const FONT_TYPE = {
  MAIN: 'main',
  ALTERNATE: 'alternate',
};

// Numbers are corresponding the OpenType Spec: https://docs.microsoft.com/en-us/typography/opentype/spec/os2#usweightclass
export const OPEN_TYPE_WEIGHT = {
  THIN: 100,
  EXTRA_LIGHT: 200,
  LIGHT: 300,
  REGULAR: 400,
  MEDIUM: 500,
  SEMIBOLD: 600,
  BOLD: 700,
  EXTRA_BOLD: 800,
  BLACK: 900,
};

export const FONT_WEIGHT = {
  ID_1: 'FONT_WEIGHT_1',
  ID_2: 'FONT_WEIGHT_2',
  ID_3: 'FONT_WEIGHT_3',
  ID_4: 'FONT_WEIGHT_4',
};

export const FONT = {
  TOKYO_4: 'tokyo_4',
  OSLO_1: 'oslo_1',
  OSLO_2: 'oslo_2',
  OSLO_3: 'oslo_3',
  PARIS_1: 'paris_1',
  PARIS_2: 'paris_2',
  PARIS_3: 'paris_3',
  KINSHASA_1: 'kinshasa_1',
  KINSHASA_2: 'kinshasa_2',
  KINSHASA_3: 'kinshasa_3',
  OTTAWA_1: 'ottawa_1',
  OTTAWA_2: 'ottawa_2',
  OTTAWA_3: 'ottawa_3',
  BERLIN_1: 'berlin_1',
  BERLIN_2: 'berlin_2',
  BERLIN_3: 'berlin_3',
  MADRID_1: 'madrid_1',
  MADRID_2: 'madrid_2',
  MADRID_3: 'madrid_3',
  BOSTON_1: 'boston_1',
  BOSTON_2: 'boston_2',
  BOSTON_3: 'boston_3',
  MEXICO_1: 'mexico_1',
  MEXICO_2: 'mexico_2',
  MEXICO_3: 'mexico_3',
  LYON_1: 'lyon_1',
  LYON_2: 'lyon_2',
  LYON_3: 'lyon_3',
};
